import React, { Component } from 'react';
import { connect } from 'react-redux';
import { navigate } from '../modules/high_level_actions';

class Contact extends Component {
  render() {
    return (
      <div className="content-max-width cms">
        <div>
          <a href="/" className="button btn-secondary float-right" onClick={(evt) => this.props.dispatch(navigate(evt))}>Continue shopping</a>
        </div>
        <div className="desk-iframe-wrapper">
          <iframe src={this.props.contact_url} frameBorder="0" width="960" height="1200"></iframe>
        </div>
      </div>
    );
  }
};

function mapStateToProps(state){
    return { 'contact_url': state.store.contact_url };
}

export default connect(mapStateToProps)(Contact);


// WEBPACK FOOTER //
// ./src/components/CmsContact.jsx